/*
    * Used to access data from the state tree of the store
*/
import { GetterTree } from "vuex";
import { RootState } from "../../../../types";
import { Announcement } from "./types";

export const getters: GetterTree<Announcement, RootState> = {
};
